import { createFileRoute } from '@tanstack/react-router'
import { ABOUT } from '../content'
import { WorkSection } from '../sections'

export const Route = createFileRoute('/about')({
  head: () => ({
    meta: [
      { title: 'about - jfrader' },
      { name: 'description', content: 'about jfrader, a full-stack engineer and his work.' },
      { property: 'og:title', content: 'about - jfrader' },
      { property: 'og:description', content: 'about jfrader, a full-stack engineer and his work.' },
      { property: 'og:url', content: 'https://jfrader.com/about' },
    ],
    links: [
      { rel: 'canonical', href: 'https://jfrader.com/about' }
    ]
  }),
  component: AboutPage,
})

function AboutPage() {
  return (
    <>
      <section className="sec">
        <h2 className="sec__label">about</h2>
        <div className="about">
          {ABOUT.map((p) => (
            <p key={p.slice(0, 24)}>{p}</p>
          ))}
        </div>
      </section>

      <WorkSection />
    </>
  )
}
